export default {
	precision(money) {
		var precision = localStorage.getItem('precision');
		return (money / 1).toFixed(precision);
	},
	precision_basic(money) {
		var precision = localStorage.getItem('precision_basic');
		var formatted = (money / 1).toFixed(precision);
		// 去掉末尾的零
		formatted = formatted.replace(/\.?0+$/, '');
		// 将小数点替换为逗号
		formatted = formatted.replace('.', ',');
		return formatted;
	},
	currency() {
		return localStorage.getItem('currency');
	},
	currency_symbol_basic(money) {
		return localStorage.getItem('currency_symbol_basic');
	}
}
